import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import useAuthStore from '@/store/authStore';
import { BridgeContext } from './context';
import { fetchDesktopFeatures } from './http';
import type { FeatureKey } from './types';

/**
 * The SmartFi Desktop feature switches (Admin Panel → SmartFi Desktop features)
 * also govern Community on the web. Anything OFF is hidden; admin and staff
 * see everything (the server answers seesAll for them) so they can test first.
 * Until the server answers, everything is hidden.
 */
export interface CommunityFeatures {
   on: (k: FeatureKey) => boolean;
   seesAll: boolean;
   loaded: boolean;
}

export function useCommunityFeatures(): CommunityFeatures {
   const isAuthed = useAuthStore((s) => s.isAuthenticated);
   const sf = useContext(BridgeContext);
   const { data } = useQuery({
      queryKey: ['desktop', 'features'],
      queryFn: async () => {
         const r = await (sf ? sf.desktopFeatures() : fetchDesktopFeatures());
         if (!r.ok) throw new Error(r.message);
         return r.data;
      },
      enabled: isAuthed,
      staleTime: 120_000,
      retry: 1,
   });
   return {
      on: (k) => !!data && (data.seesAll || !!data.features[k]),
      seesAll: !!data?.seesAll,
      loaded: !!data,
   };
}
